<template>
  <router-view />
</template>
<script>
export default {
  name: "Main",
};
</script>
<style>
@import "./assets/css/style.css";
</style>